import axios from 'axios';

// Add axios interceptor to include Authorization header from localStorage
// This ensures Safari and mobile browsers work even when cookies are blocked
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('session_token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear invalid token
      localStorage.removeItem('session_token');
      // Don't redirect - let components handle 401 gracefully
      // Components like Navbar already handle auth check failures
    }
    return Promise.reject(error);
  }
);

export default axios;
